import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import { Chip, Typography } from '@material-ui/core';
import { Clear as ClearIcon } from '@material-ui/icons';

import SelectComponent from './SelectComponent';
import Option from './Option';
import SelectArrow from './SelectArrow';

const styles = ({
  custom: {
    palette: { colorSupportPowder, colorSuportSteel },
  },
  palette: { primary },
  spacing: { unit },
}) => ({
  chipIcon: {
    color: colorSuportSteel,
    display: 'inline-block',
    float: 'right',
    height: '16px',
    margin: 8,
    width: '16px',
    '&$hidden': {
      display: 'none !important',
    },
  },
  chipLabel: {
    display: 'inline-block',
    float: 'left',
    fontSize: 14,
    lineHeight: '30px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  chipRoot: {
    backgroundColor: colorSupportPowder,
    borderRadius: '0px',
    color: primary.main,
    display: 'inline-flex',
    height: 30,
    margin: unit / 2,
    maxWidth: `calc(100% - ${unit * 3}px)`,
  },
  roundedChip: {
    borderRadius: 3,
  },
  clearIcon: {
    color: primary.main,
    padding: unit,
  },
  hidden: {},
  noResults: {
    color: primary.main,
    fontWeight: 500,
  },
});

class SelectWrapped extends Component {
  constructor(props) {
    super(props);

    this.renderClearIcon = this.renderClearIcon.bind(this);
    this.renderValueComponent = this.renderValueComponent.bind(this);
  }

  renderClearIcon() {
    const { classes, clearable, clearIconClassName, clearIconRenderer } = this.props;

    if (!clearable) return;

    if (clearIconRenderer) return clearIconRenderer;

    return <ClearIcon className={classnames(classes.clearIcon, clearIconClassName || {})} />;
  }

  renderValueComponent(valueProps) {
    const { classes, rounded, disabled } = this.props;
    const { children, onRemove, value } = valueProps;
    const onDelete = (event) => {
      event.preventDefault();
      event.stopPropagation();

      onRemove(value);
    };

    if (onRemove) {
      return (
        <Chip
          tabIndex={-1}
          label={children}
          classes={{
            label: classes.chipLabel,
            root: classnames(classes.chipRoot, { [classes.roundedChip]: rounded }),
          }}
          deleteIcon={
            <ClearIcon
              className={classnames(classes.chipIcon, { [classes.hidden]: !value.clearableValue || disabled })}
            />
          }
          onDelete={onDelete}
        />
      );
    }

    return <div className="Select-value">{children}</div>;
  }

  renderNoResults() {
    const { classes, hideNoResults } = this.props;

    if (hideNoResults) return false;

    return <Typography className={classes.noResults}>No results found</Typography>;
  }

  render() {
    const { classes, clearable, multi, optionComponent, valueComponent, hideArrow, ...other } = this.props;

    return (
      <SelectComponent
        arrowRenderer={(arrowProps) => !hideArrow && <SelectArrow arrowProps={arrowProps} />}
        clearRenderer={this.renderClearIcon}
        clearable={clearable || (clearable === undefined && multi)}
        closeOnSelect={!multi}
        onSelectResetsInput
        multi={multi}
        noResultsText={this.renderNoResults()}
        optionComponent={optionComponent || Option}
        resetValue=""
        valueComponent={valueComponent || this.renderValueComponent}
        {...other}
      />
    );
  }
}

SelectWrapped.propTypes = {
  clearable: PropTypes.bool,
  clearIconClassName: PropTypes.string,
  clearIconRenderer: PropTypes.node,
  classes: PropTypes.object.isRequired,
  hideArrow: PropTypes.bool.isRequired,
  hideNoResults: PropTypes.bool,
  multi: PropTypes.bool.isRequired,
  rounded: PropTypes.bool,
  optionComponent: PropTypes.func,
  selectRef: PropTypes.func,
  valueComponent: PropTypes.func,
};

export default withStyles(styles)(SelectWrapped);
